<template>
	<div>
		<slot name="default" />
		<ul
			class="divide-y divide-neutral-100"
			data-autocomplete-dropdown
		>
			<template v-if="resultList?.length">
				<li
					v-for="(result, index) in resultList"
					:key="index"
					:class="[
						'first:rounded-t-md last:rounded-b-md select-none cursor-pointer px-2 py-3 hover:bg-accented/85 whitespace-nowrap text-ellipsis overflow-hidden flex items-center space-x-2 shrink-0',
						{ 'bg-accented': activeSearchItem === index },
						{ 'rounded-b-lg': index === resultList.length - 1 }
					]"
					@mousedown="handleSetSearchTerm(result.desc, result.id, index)"
				>
					<UIcon
						name="i-lucide-map-pin"
						class="h-8 w-8 shrink-0 text-primary"
					/>
					<span>
						{{ result?.desc }}
					</span>
				</li>
			</template>
		</ul>
	</div>
</template>

<script setup lang="ts">
import type { ResultList } from '@/types/components/address-checker'

const props = defineProps({
	resultList: {
		type: Array as PropType<ResultList[]>,
		required: true
	},
	activeSearchItem: {
		type: Number,
		required: true
	}
})

const {
	resultList,
	activeSearchItem
} = toRefs(props)

const emit = defineEmits([ 'setSearchTerm' ])

const handleSetSearchTerm = (searchTerm: string, id: string, index: number) => {
	emit('setSearchTerm', searchTerm, id, index)
}
</script>
